export default __webpack_public_path__ + "static/media/charts-seedj.85cca2a9.png";